import styled from 'styled-components';
export const IconWrapper = styled.div `
  cursor: pointer;
  display: inline-flex;
  position: relative;
`;
export const OutlineIcon = styled.div `
  display: flex;

  ${IconWrapper}:hover & {
    display: none;
  }
`;
export const FilledIcon = styled.div `
  display: none;

  ${IconWrapper}:hover & {
    display: flex;
  }
`;
